const LTR_STYLE = { direction: "ltr" };

/**
 * A value that reads left to right on either page — a signed amount, a percentage.
 *
 * It isolates the value the way `<bdi dir="ltr">` does, and also sets the direction
 * inline: the Arabic layer's `.ar * { direction: rtl }` outranks the `dir` attribute, so
 * on its own `<bdi dir="ltr">` still lays the value out right to left and turns
 * "-24,150.00" into "24,150.00-". Inline on an inline element, so unlike `direction` on a
 * block it leaves the surrounding text alignment alone.
 *
 * @param {string} [className]
 */
const LtrText = ({ className, children }) => (
  <bdi dir="ltr" style={LTR_STYLE} className={className}>
    {children}
  </bdi>
);

export default LtrText;
